export enum RoutesConst {
  //Setup
  AdminSetupList = '/private/uwsetup/admin',

  //CompanyPage
  CompanyList = '/private/company',

  //campaign
  CreateCampaign =  '/private/campaign/create',
  CampaignList = '/private/campaign',
}
